import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  private _accessToken: string;
  private _role: string;
  private _refreshToken: string;
  private _vendor: string;
  private _portal: string;
  private _previewPage: string;
  private _captivePortalBaseUrl: string;
  private _npgUrl: string;
  private _npgPublicKey: string;
  private _packagePriceLimit: number;

  constructor() {
    this._accessToken = localStorage.getItem('accessToken');
    this._refreshToken = localStorage.getItem('refreshToken');
    this._vendor = localStorage.getItem('vendor');
    this._npgPublicKey = localStorage.getItem('npgPubKey');
    this._npgUrl = localStorage.getItem('npgUrl');
    this._packagePriceLimit = localStorage.getItem('packagePriceLimit') ? Number(localStorage.getItem('packagePriceLimit')) : 0;
  }

  get accessToken(): string {
    return this._accessToken;
  }

  set accessToken(value: string) {
    if(value && value !== 'undefined'){
      this._accessToken = value;
      localStorage.setItem('accessToken', value)
    }else{
      this._accessToken = undefined;
      localStorage.removeItem('accessToken')
    }
  }

  get npgPublicKey(): string {
    return this._npgPublicKey;
  }

  set npgPublicKey(value: string) {
    this._npgPublicKey = value;
    localStorage.setItem('npgPubKey', value)
  }

  get npgUrl(): string {
    return this._npgUrl;
  }

  set npgUrl(value: string) {
    this._npgUrl = value;
    localStorage.setItem('npgUrl', value)
  }

  get role(): string {
    return this._role;
  }

  set role(value: string) {
    this._role = value;
    localStorage.setItem('role', value)
  }

  get refreshToken(): string {
    return this._refreshToken;
  }

  set refreshToken(value: string) {
    this._refreshToken = value;
    localStorage.setItem('refreshToken', value)
  }

  get vendor(): any {
    return JSON.parse(this._vendor);
  }

  set vendor(value: any) {
    this._vendor = JSON.stringify(value);
    localStorage.setItem('vendor', this._vendor)
  }

  get portal(): any {
    return JSON.parse(this._portal);
  }

  set portal(value: any) {
    this._portal = JSON.stringify(value);
    localStorage.setItem('portal', this._portal)
  }

  get previewPage(): string {
    return this._previewPage;
  }

  set previewPage(value: string) {
    this._previewPage = value;
    localStorage.setItem('previewPage', value)
  }

  get captivePortalBaseUrl(): string {
    return this._captivePortalBaseUrl;
  }

  set captivePortalBaseUrl(value: string) {
    this._captivePortalBaseUrl = value;
    localStorage.setItem('captivePortalBase', value)
  }
  
  get packagePriceLimit(): number {
    return this._packagePriceLimit;
  }

  set packagePriceLimit(value: number){
    this._packagePriceLimit = value;
    localStorage.setItem('packagePriceLimit', ''+value);
  }

  getTokenAttributes(token){
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token);
    return decodedToken;
  }
}
